import { render, staticRenderFns } from "./creatComment.vue?vue&type=template&id=0d709300&scoped=true"
import script from "./creatComment.vue?vue&type=script&lang=js"
export * from "./creatComment.vue?vue&type=script&lang=js"
import style0 from "./creatComment.vue?vue&type=style&index=0&id=0d709300&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d709300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d709300')) {
      api.createRecord('0d709300', component.options)
    } else {
      api.reload('0d709300', component.options)
    }
    module.hot.accept("./creatComment.vue?vue&type=template&id=0d709300&scoped=true", function () {
      api.rerender('0d709300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/comment/creatComment.vue"
export default component.exports